export const PAN_STATUS_VARIANTS = {
  PAN_VERIFIED: "PAN_VERIFIED",
  PAN_UNAVAILABLE_CHECKED: "PAN_UNAVAILABLE_CHECKED",
  PAN_UNAVAILABLE_UNCHECKED: "PAN_UNAVAILABLE_UNCHECKED",
  PAN_INACTIVE: "PAN_INACTIVE",
  PAN_INOPERATIVE: "PAN_INOPERATIVE",
  PAN_ASSOCIATION: "PAN_ASSOCIATION",
  PENDING: "PENDING",
};
